import React from 'react';
import { Filter, Grid, List, Search } from 'lucide-react';
import { Input } from './ui/input';

const ReportToolbar = ({
  searchValue,
  onSearchChange,
  searchPlaceholder,
  filterContent,
  reportCount,
  viewMode,
  onViewModeChange,
  testId,
}) => (
  <div className="bg-white border-y border-slate-200 sticky top-[124px] z-30">
    <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-4">
      <div className="flex flex-col lg:flex-row lg:items-center gap-3">
        <div className="relative flex-1 min-w-0">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
          <Input
            type="search"
            placeholder={searchPlaceholder}
            value={searchValue}
            onChange={(event) => onSearchChange(event.target.value)}
            className="h-14 pl-12 bg-white border-slate-200 rounded-xl focus:border-[#C8A84B] focus:ring-0"
            data-testid={testId ? `${testId}-search-input` : undefined}
          />
        </div>
        <div className="flex items-center gap-2 min-w-0">
          <Filter className="w-4 h-4 flex-shrink-0 text-slate-500" />
          <span className="text-sm font-medium text-slate-700 flex-shrink-0">Filters:</span>
          <div className="flex flex-wrap items-center gap-2 min-w-0">{filterContent}</div>
        </div>
        <div className="flex items-center gap-2 bg-slate-100 p-1 rounded-lg" data-testid={testId ? `${testId}-view-toggle` : undefined}>
          <button type="button" onClick={() => onViewModeChange('grid')} className={`p-2 rounded transition-colors ${viewMode === 'grid' ? 'bg-white shadow-sm' : 'hover:bg-slate-50'}`} aria-label="Grid view">
            <Grid className="w-4 h-4 text-slate-700" />
          </button>
          <button type="button" onClick={() => onViewModeChange('list')} className={`p-2 rounded transition-colors ${viewMode === 'list' ? 'bg-white shadow-sm' : 'hover:bg-slate-50'}`} aria-label="List view">
            <List className="w-4 h-4 text-slate-700" />
          </button>
        </div>
        <div className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-700 whitespace-nowrap">
          <span className="h-2 w-2 rounded-full bg-emerald-500 animate-pulse" />
          {reportCount} Reports
        </div>
      </div>
    </div>
  </div>
);

export default ReportToolbar;
